'use strict';

var base58 = require('bs58');

var multihash = require('multihashes');

var multibase = require('multibase');

var CID = require('cids');

var urlPattern = /^https?:\/\/[^/]+\/(ip(f|n)s)\/((\w+).*)/;
var pathPattern = /^\/(ip(f|n)s)\/((\w+).*)/;
var defaultProtocolMatch = 1;
var defaultHashMath = 4;
var fqdnPattern = /^https?:\/\/([^/]+)\.(ip(?:f|n)s)\.[^/]+/;
var fqdnHashMatch = 1;
var fqdnProtocolMatch = 2;

function isMultihash(hash) {
  var formatted = convertToString(hash);

  try {
    var buffer = Buffer.from(base58.decode(formatted));
    multihash.decode(buffer);
    return true;
  } catch (e) {
    return false;
  }
}

function isMultibase(hash) {
  try {
    return multibase.isEncoded(hash);
  } catch (e) {
    return false;
  }
}

function isCID(hash) {
  try {
    return CID.isCID(new CID(hash));
  } catch (e) {
    return false;
  }
}

function isIpfs(input, pattern) {
  var protocolMatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultProtocolMatch;
  var hashMatch = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : defaultHashMath;
  var formatted = convertToString(input);

  if (!formatted) {
    return false;
  }

  var match = formatted.match(pattern);

  if (!match) {
    return false;
  }

  if (match[protocolMatch] !== 'ipfs') {
    return false;
  }

  var hash = match[hashMatch];

  if (hash && pattern === fqdnPattern) {
    // when doing checks for subdomain context
    // ensure hash is case-insensitive
    // (browsers force-lowercase authority compotent anyway)
    hash = hash.toLowerCase();
  }

  return isCID(hash);
}

function isIpns(input, pattern) {
  var protocolMatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultProtocolMatch;
  var hashMatch = arguments.length > 3 ? arguments[3] : undefined;
  var formatted = convertToString(input);

  if (!formatted) {
    return false;
  }

  var match = formatted.match(pattern);

  if (!match) {
    return false;
  }

  if (match[protocolMatch] !== 'ipns') {
    return false;
  }

  if (hashMatch && pattern === fqdnPattern) {
    var hash = match[hashMatch]; // when doing checks for subdomain context
    // ensure hash is case-insensitive
    // (browsers force-lowercase authority compotent anyway)

    hash = hash.toLowerCase();
    return isCID(hash);
  }

  return true;
}

function convertToString(input) {
  if (Buffer.isBuffer(input)) {
    return base58.encode(input);
  }

  if (typeof input === 'string') {
    return input;
  }

  return false;
}

var ipfsSubdomain = function ipfsSubdomain(url) {
  return isIpfs(url, fqdnPattern, fqdnProtocolMatch, fqdnHashMatch);
};

var ipnsSubdomain = function ipnsSubdomain(url) {
  return isIpns(url, fqdnPattern, fqdnProtocolMatch, fqdnHashMatch);
};

module.exports = {
  multihash: isMultihash,
  cid: isCID,
  base32cid: function base32cid(cid) {
    return isMultibase(cid) === 'base32' && isCID(cid);
  },
  ipfsSubdomain: ipfsSubdomain,
  ipnsSubdomain: ipnsSubdomain,
  subdomain: function subdomain(url) {
    return ipfsSubdomain(url) || ipnsSubdomain(url);
  },
  subdomainPattern: fqdnPattern,
  ipfsUrl: function ipfsUrl(url) {
    return isIpfs(url, urlPattern);
  },
  ipnsUrl: function ipnsUrl(url) {
    return isIpns(url, urlPattern);
  },
  url: function url(_url) {
    return isIpfs(_url, urlPattern) || isIpns(_url, urlPattern);
  },
  urlPattern: urlPattern,
  ipfsPath: function ipfsPath(path) {
    return isIpfs(path, pathPattern);
  },
  ipnsPath: function ipnsPath(path) {
    return isIpns(path, pathPattern);
  },
  path: function path(_path) {
    return isIpfs(_path, pathPattern) || isIpns(_path, pathPattern);
  },
  pathPattern: pathPattern,
  urlOrPath: function urlOrPath(x) {
    return isIpfs(x, urlPattern) || isIpns(x, urlPattern) || isIpfs(x, pathPattern) || isIpns(x, pathPattern);
  }
};